<template>
  <div ref="SpTagGroup" class="SpTagGroup flex">
    <!-- <sp-tag v-for="(tag,index) in tags" :key="index" v-model="model" :content="$l(tag.content)" :click-handle="tag.clickHandle" /> -->
    <slot />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'SpTagGroup',

  nameSpace: 'SpTagGroup',

  components: {
  },

  props: {
    // tags: {
    //   type: Array,
    //   default () {
    //     return []
    //   }
    // },

    modelValue: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue', 'change'],

  data () {
    return {
    }
  },

  computed: {
    model: {
      get () {
        return this.modelValue
      }
    }
  },

  watch: {
    modelValue (nv) {
      this.$emit('update:modelValue', nv)
      this.$emit('change', nv)
    }
  },

  created () {
  },

  mounted () {
  },

  methods: {
  }
}
</script>

<style scoped lang="less">
.SpTagGroup{
}
</style>
